(() => {
  const root = document.documentElement;
  root.classList.add('js');

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const revealItems = [...document.querySelectorAll('[data-reveal]')];
  if (reducedMotion || !('IntersectionObserver' in window)) {
    revealItems.forEach((item) => item.classList.add('is-visible'));
  } else {
    const revealObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    revealItems.forEach((item) => revealObserver.observe(item));
  }

  document.querySelectorAll('[data-product-form]').forEach((scope) => {
    const select = scope.querySelector('[data-variant-select]');
    const price = scope.querySelector('[data-product-price]');
    const comparePrice = scope.querySelector('[data-compare-price]');
    const submit = scope.querySelector('[data-add-to-cart]');
    const availability = scope.querySelector('[data-availability]');
    if (!select || !submit) return;

    const syncVariant = () => {
      const option = select.selectedOptions[0];
      if (!option) return;
      const available = option.dataset.available === 'true';
      if (price) price.textContent = option.dataset.price || '';
      if (comparePrice) {
        comparePrice.textContent = option.dataset.comparePrice || '';
        comparePrice.hidden = !option.dataset.comparePrice;
      }
      submit.disabled = !available;
      submit.textContent = available ? submit.dataset.availableLabel : submit.dataset.soldOutLabel;
      if (availability) availability.textContent = available ? availability.dataset.inStock : availability.dataset.outOfStock;
    };

    select.addEventListener('change', syncVariant);
    syncVariant();
  });

  document.querySelectorAll('[data-quantity]').forEach((scope) => {
    const input = scope.querySelector('input[type="number"]');
    if (!input) return;
    scope.querySelectorAll('[data-quantity-change]').forEach((button) => {
      button.addEventListener('click', () => {
        const delta = Number(button.dataset.quantityChange);
        const minimum = Number(input.min || 1);
        input.value = Math.max(minimum, Number(input.value || minimum) + delta);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });

  document.querySelectorAll('[data-predictive-search]').forEach((form) => {
    const input = form.querySelector('[data-predictive-input]');
    const results = form.querySelector('[data-predictive-results]');
    const endpoint = form.dataset.predictiveUrl;
    if (!input || !results || !endpoint) return;
    let timer;
    let requestController;

    const closeResults = () => {
      results.hidden = true;
      results.replaceChildren();
      input.setAttribute('aria-expanded', 'false');
    };

    const renderResults = (payload) => {
      const resources = payload?.resources?.results || {};
      const items = [...(resources.products || []), ...(resources.articles || []), ...(resources.pages || [])].slice(0, 6);
      if (!items.length) {
        closeResults();
        return;
      }

      const list = document.createElement('ul');
      items.forEach((item) => {
        const entry = document.createElement('li');
        const link = document.createElement('a');
        link.href = item.url;
        link.textContent = item.title;
        entry.append(link);
        list.append(entry);
      });
      results.replaceChildren(list);
      results.hidden = false;
      input.setAttribute('aria-expanded', 'true');
    };

    input.addEventListener('input', () => {
      clearTimeout(timer);
      const query = input.value.trim();
      if (query.length < 2) {
        closeResults();
        return;
      }
      timer = window.setTimeout(() => {
        requestController?.abort();
        requestController = new AbortController();
        const url = new URL(endpoint, window.location.origin);
        url.searchParams.set('q', query);
        url.searchParams.set('resources[type]', 'product,article,page');
        url.searchParams.set('resources[limit]', '6');
        fetch(url, { signal: requestController.signal })
          .then((response) => response.ok ? response.json() : Promise.reject(new Error('Predictive search failed')))
          .then(renderResults)
          .catch((error) => { if (error.name !== 'AbortError') closeResults(); });
      }, 180);
    });

    document.addEventListener('click', (event) => {
      if (!form.contains(event.target)) closeResults();
    });
  });

  document.querySelectorAll('[data-article-body]').forEach((body) => {
    const navigation = document.querySelector('[data-article-toc]');
    const list = navigation?.querySelector('[data-article-toc-list]');
    const headings = [...body.querySelectorAll('h2')];
    if (!navigation || !list || headings.length < 2) return;

    headings.forEach((heading, index) => {
      if (!heading.id) heading.id = `chapter-${index + 1}`;
      const item = document.createElement('li');
      const link = document.createElement('a');
      const number = document.createElement('span');
      number.textContent = String(index + 1).padStart(2, '0');
      link.href = `#${heading.id}`;
      link.append(number, document.createTextNode(heading.textContent));
      item.append(link);
      list.append(item);
    });
    navigation.hidden = false;
  });
})();
